<template>
  <div class="parent">
    <div class="btn-box">
      <BBtnSecondary
        :img-src="require('@/assets/edit.png')"
        :clicked="edit"
        v-if="editFlag == 'false'"
        hidden-key="true"
        btn-txt="编辑"
      />
    </div>
    <div class="box">
      <b>课程名称：</b>
      <span>{{ courseInfo.courseName }}</span>
    </div>
    <div class="box">
      <b>课程专业：</b>
      <span>{{ courseInfo.courseMajorName }}</span>
    </div>
    <div class="box">
      <b>课程课时：</b>
      <span>{{ courseInfo.courseTime }}</span>
    </div>
    <div class="box">
      <label class="labelClass">课程简介：</label>
      <pre style="width:400px; white-space:pre-wrap; font-family:'Source Han Sans CN' ">{{ courseInfo.remark }}</pre>
    </div>
  </div>
</template>

<script>
import { courseDetail } from "@/api/course";
import BBtnSecondary from "../../components2/BBtnSecondary";
export default {
  /* 父子组件传参 data中定义的参数不能与props中定义的参数名一致 */
  props: ["courseId"],
  components: {
    BBtnSecondary,
  },
  data() {
    return {
      snackbarObj: {
        snackbar: false,
        timeout: -1,
        color: "",
        text: "",
      },
      // 课程信息
      courseInfo: {},
      // 班级
      trainClassList: [],
      // 普通签到List
      ordinaryList: [],
      data_courseId: "",
      editFlag: sessionStorage.getItem("editFlag").toString(),
      navi: [
        { name: "course-management" },
        { name: "course-management-detail" },
      ],
    };
  },

  mounted() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
    if (this.$props.courseId !== null && this.$props.courseId !== undefined) {
      this.data_courseId = this.$props.courseId;
      this.courseDetail(this.data_courseId);
    }
  },
  methods: {
    // 返回
    back() {
      this.$router.push({ name: "course-management", query: { backFlg: "1" } });
    },
    // 详情
    edit() {
      this.$router.push({
        name: "course-management-add",
        params: {
          courseId: this.data_courseId,
        },
      });
    },
    async courseDetail(id) {
      var param = {
        id: id,
      };
      const data = await courseDetail(param);
      this.courseInfo = {
        courseName: data.data.courseName,
        courseMajorName: data.data.courseMajorName,
        courseTime: data.data.courseTime,
        remark: data.data.remark,
        status: data.data.status,
      };
      this.ordinaryList = data.data.ordinaryList;
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  /* align-items: center; */
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.btn-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1em;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}

.setting {
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
}

.parent {
  margin: 1.5em 2em;
}

.mr-20 {
  margin-right: 20px;
}
.labelClass {
    /* text-align: right; */
    font-weight: bold;
}
</style>
